import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { legal } from "../i18n/legal";
import { LegalPage } from "../components/legal/LegalPage";
export function TermsOfService() {
  const {
    lang
  } = useLanguage();
  return <LegalPage content={legal[lang].terms} data-id="element-308" data-mp="33uia14n0nl52" />;
}